var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoBoutique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3339",
    "data-name": "Groupe 3339",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.321,
    height: 14.369,
    viewBox: "0 0 16.321 14.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 16.321,
    height: 14.369,
    fill: "#a85dfa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3340",
    "data-name": "Groupe 3340",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1170",
    "data-name": "Trac\\xE9 1170",
    d: "M39.47,0,38.362,4.3l0,.006-.007.029v.873a1.374,1.374,0,0,0,.315.878,1.382,1.382,0,0,0,.528.394,1.375,1.375,0,0,0,.537.108,1.4,1.4,0,0,0,.141-.007,1.379,1.379,0,0,0,1.239-1.373v-.9h.008L41.683,0Z",
    transform: "translate(-34.95)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1171",
    "data-name": "Trac\\xE9 1171",
    d: "M2.376,0a1.12,1.12,0,0,0-1.05.73L0,4.309v.9a1.38,1.38,0,0,0,2.76,0v-.9h.006L3.876,0Z",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1172",
    "data-name": "Trac\\xE9 1172",
    d: "M141.552,4.154l.011.044.02.076v.937c0,.015,0,.029,0,.044a1.4,1.4,0,0,0,.055.345c0,.01.005.021.008.031q.019.06.043.117a1.383,1.383,0,0,0,.3.439q.047.047.1.089a1.38,1.38,0,0,0,2.258-1.065v-.9L143.015.73a1.121,1.121,0,0,0-1.05-.73h-1.481l1.05,4.079Z",
    transform: "translate(-128.019)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1173",
    "data-name": "Trac\\xE9 1173",
    d: "M77.961,0h-.69l-.562,4.3v.006l0,.013v.889a1.379,1.379,0,0,0,2.758.044c0-.015,0-.029,0-.044V4.436l-.006-.047L78.894.08,78.883,0h-.922Z",
    transform: "translate(-69.9)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1174",
    "data-name": "Trac\\xE9 1174",
    d: "M109.01,4.153l.01.076.006.043.005.04v.9c0,.015,0,.029,0,.044a1.378,1.378,0,0,0,2.756,0c0-.015,0-.029,0-.044V4.427l-1.1-4.272L110.645,0h-2.177Z",
    transform: "translate(-98.844)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1175",
    "data-name": "Trac\\xE9 1175",
    d: "M134.142,4.427v.784c0,.015,0,.029,0,.044,0-.015,0-.029,0-.044V4.352l-.011-.044-.019-.075L133.024,0H133l.04.155Z",
    transform: "translate(-121.202)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    "data-name": "Trac\\xE9 1176",
    d: "M108.883,4.352v-.04l-.005-.04-.006-.043-.01-.076L108.32,0h-.014l.563,4.309h.011v.9c0,.015,0,.029,0,.044,0-.015,0-.029,0-.044Z",
    transform: "translate(-98.697)",
    fill: "#a85dfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1177",
    "data-name": "Trac\\xE9 1177",
    d: "M16.876,70.607a2,2,0,0,1-3.378,0,2,2,0,0,1-3.39-.02,2,2,0,0,1-3.4,0,2,2,0,0,1-2.728.665v5.7a1.741,1.741,0,0,0,1.741,1.741H8.844a.736.736,0,0,0,.736-.736V73.363a.684.684,0,0,1,.684-.684h3.151a.684.684,0,0,1,.684.684v4.595a.736.736,0,0,0,.736.736H17.91a1.741,1.741,0,0,0,1.741-1.741V71.215a2,2,0,0,1-2.775-.608",
    transform: "translate(-3.624 -64.324)",
    fill: "#a85dfa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBoutique);
export default __webpack_public_path__ + "static/media/picto-boutique.0d7eebae608960f0b387ff6ae1bfecc8.svg";
export { ForwardRef as ReactComponent };